import { createContext, useContext } from 'react';

import type { PlaceOrderContextValue } from 'pages/place_order';

export const PlaceOrderContext = createContext({} as PlaceOrderContextValue);
PlaceOrderContext.displayName = 'PlaceOrderContext';

export const usePlaceOrder = () => useContext(PlaceOrderContext);
